export default "__VITE_ASSET__BxWpwhMw__"